<template>
  <HeaderBlock msg="HeaderBlock" />
  <NavBlock msg="NavBlock" />
  <!-- title -->
  <div class="page-wrapper">
    <div class="page-header d-print-none">
      <div class="container-xl">
        <div class="row g-2 align-items-center">
          <div class="col">
            <!-- Page pre-title -->
            <div class="page-pretitle"></div>
            <h3 class="card-body">
              <ol class="breadcrumb breadcrumb-arrows">
                <li class="breadcrumb-item" :class="{ 'active': step == 1 }"><a href="#" @click="goStep(1)">开始准备</a>
                </li>
                <li class="breadcrumb-item" :class="{ 'active': step == 2 }"><a href="#" @click="goStep(2)">安装MQTT</a>
                </li>
                <li class="breadcrumb-item" :class="{ 'active': step == 3 }"><a href="#" @click="goStep(3)">设置MQTT</a>
                </li>
                <li class="breadcrumb-item" :class="{ 'active': step == 4 }"><a href="#"
                    @click="goStep(4)">设置configuration</a></li>
                <li class="breadcrumb-item" :class="{ 'active': step == 5 }"><a href="#" @click="goStep(5)">完成</a></li>
              </ol>
            </h3>
          </div>
        </div>
      </div>
    </div>
    <!-- table -->
    <div class="page-body">
      <!-- 1 -->
      <div class="container container-tight py-4" v-if="step == 1">
        <h2 class="mb-3">开始准备</h2>
        <p class="text-secondary">
          <b  class="text-orange">此教程通过 MQTT 进行接入，此处作为保留，不再更新。</b>
        </p>
        <p class="text-secondary">
          强烈推荐使用 <a href="/home_assistant">Sumsg Smart</a> 集成进行接入。<br/><br/>
          以下是本设备使用Home Assistant的必要条件。本设备使用MQTT协议接入Home Assistant。
        </p>
        <ul class="list-unstyled space-y">
          <li class="row g-2">
            <span class="col-auto"> <i class="fa fa-check-circle text-success"></i> </span>
            <span class="col">
              <strong class="d-block">远程开机卡</strong>
              <span class="d-block text-secondary">目前适配了远程开机卡一代和二代，本平台其他设备未适配。</span>
            </span>
          </li>
          <li class="row g-2">
            <span class="col-auto"> <i class="fa fa-check-circle text-success"></i> </span>
            <span class="col">
              <strong class="d-block">Home Assistant服务</strong>
              <span class="d-block text-secondary">已经成功安装Home Assistant服务，并可以正常使用。</span>
            </span>
          </li>
          <li class="row g-2">
            <span class="col-auto"> <i class="fa fa-check-circle text-success"></i> </span>
            <span class="col">
              <strong class="d-block">MQTT集成未使用</strong>
              <span class="d-block text-secondary">MQTT集成只能配置一次。如果您想体验本设备，请使用本教程的配置覆盖现有的配置。</span>
            </span>
          </li>
          <li class="row g-2">
            <span class="col-auto"> <i class="fa fa-check-circle text-success"></i> </span>
            <span class="col">
              <strong class="d-block">设备绑定成功</strong>
              <span class="d-block text-secondary">设备需要成功配网，APP能正常控制。</span>
            </span>
          </li>
          <li class="row g-2">
            <span class="col-auto"> <i class="fa fa-check-circle text-default"></i> </span>
            <span class="col">
              <strong class="d-block">桌面电脑</strong>
              <span class="d-block text-secondary">可以访问Home Assistant服务配置的桌面电脑，用来配置。非必须。</span>
            </span>
          </li>
        </ul>
        <div class="my-4">
          <a class="btn btn-primary w-100" @click="goStep(2)">
            下一步 安装MQTT
          </a>
        </div>
        <p class="text-secondary">
        </p>
      </div>
      <!-- 2 -->
      <div class="container container-tight py-4" v-if="step == 2">
        <h2 class="mb-3">安装MQTT</h2>
        <p class="text-secondary mb-4">
          <a href="https://www.home-assistant.io/integrations/mqtt/#mqtt-discovery" target="_blank">
            官方参考文档（英文）
          </a>
        </p>
        <ul class="steps steps-counter steps-vertical">
          <li class="step-item">
            <div class="h4 m-0"><i class="fa-solid fa-gear"></i> 打开“配置” ➔ “设备与服务”</div>
            <div class="text-secondary">
              <p></p>
              <p>在页面左下角找到“设置”。</p>
              <p>在页面中间第二行。集成、设备、实体和辅助元素</p>
              <p>
                <a href="/img/home_assistant/mqtt_install_1.png" target="_blank">
                  <img src="/img/home_assistant/mqtt_install_1.png" class="img-big">
                </a>
              </p>
            </div>
          </li>
          <li class="step-item">
            <div class="h4 m-0"><i class="fa-solid fa-plus"></i> 打开“添加集成”</div>
            <div class="text-secondary">
              <p></p>
              <p>在页面右下角找到“添加集成”。</p>
              <p>
                <a href="/img/home_assistant/mqtt_install_2.png" target="_blank">
                  <img src="/img/home_assistant/mqtt_install_2.png" class="img-big">
                </a>
              </p>
            </div>
          </li>
          <li class="step-item">
            <div class="h4 m-0"><i class="fa-solid fa-gear"></i> 安装“MQTT”集成</div>
            <div class="text-secondary">
              <p></p>
              <p>搜索“MQTT”，然后选择第一项。</p>
              <p>
                <a href="/img/home_assistant/mqtt_install_3.png" target="_blank">
                  <img src="/img/home_assistant/mqtt_install_3.png" class="img-big">
                </a>
              </p>
            </div>
          </li>
          <li class="step-item active"><i class="fa-solid fa-gear"></i> 设置MQTT</li>
        </ul>
        <div class="my-4">
          <div class="row">
            <div class="col-6">
              <a class="btn btn-default w-100" @click="goStep(1)">上一步 开始准备</a>
            </div>
            <div class="col-6">
              <a class="btn btn-primary w-100" @click="goStep(3)">下一步 设置MQTT</a>
            </div>
          </div>
        </div>
        <p class="text-secondary">
        </p>
      </div>
      <!-- 3 -->
      <div class="container container-tight py-4" v-if="step == 3">
        <h2 class="mb-3">设置MQTT</h2>
        <p class="text-secondary mb-4">
          <a href="https://www.home-assistant.io/integrations/mqtt/#mqtt-discovery" target="_blank">
            官方参考文档（英文）
          </a>
        </p>
        <ul class="steps steps-counter steps-vertical">
          <li class="step-item">
            <div class="h4 m-0"><i class="fa-solid fa-gear"></i> 打开“配置” ➔ “设备与服务”</div>
            <div class="text-secondary">
              <p></p>
              <p>
                需要输入服务器，端口，用户名以及密码<br /><b>（⚠️注意：这里的用户名和密码并不是您账户的用户名和密码）。</b>
              </p>
              <p>用户名和密码也可以在APP中找到，路径：我的->关于->开发，其中Key是用户名，Secret是密码。</p>
              <p> 请把以下信息输入到 Home Assistant 的 MQTT 设置里并提交。</p>
              <div class="card card-border">
                <div class="card-body">
                  <div class="mb-3">
                    <div class="form-floating mb-3">
                      <input type="text" class="form-control" autocomplete="off" v-model="MQTTConfig.broker" readonly>
                      <label for="floating-input">服务器*</label>
                    </div>
                    <div class="form-floating mb-3">
                      <input type="text" class="form-control" autocomplete="off" v-model="MQTTConfig.port" readonly>
                      <label for="floating-input">端口*</label>
                    </div>
                    <div class="form-floating mb-3">
                      <input type="text" class="form-control" autocomplete="off" v-model="MQTTConfig.username" readonly>
                      <label for="floating-input">用户名*</label>
                    </div>
                    <div class="form-floating mb-3">
                      <input type="text" class="form-control" autocomplete="off" v-model="MQTTConfig.password" readonly>
                      <label for="floating-input">密码*</label>
                    </div>
                  </div>
                </div>
              </div>
              <p></p>
              <p>如下图所示</p>
              <p>
                <a href="/img/home_assistant/mqtt_setting_1.png" target="_blank">
                  <img src="/img/home_assistant/mqtt_setting_1.png" class="img-big">
                </a>
              </p>
            </div>
          </li>
          <li class="step-item">
            <div class="h4 m-0"><i class="fa-solid fa-close"></i> 重新配置 MQTT</div>
            <div class="text-secondary">
              <p></p>
              <p> MQTT ➔ 下一步 ➔ MQTT 选项</p>
              <p>
                <a href="/img/home_assistant/mqtt_config_3.png" target="_blank">
                  <img src="/img/home_assistant/mqtt_config_3.png" class="img-big">
                </a>
              </p>
              <p>弹出的窗口中点 下一步 ➔ MQTT 选项</p>
              <p>
                <a href="/img/home_assistant/mqtt_setting_4.png" target="_blank">
                  <img src="/img/home_assistant/mqtt_setting_4.png" class="img-big">
                </a>
              </p>
              <p class="text-danger">务必关闭“启用发现”，“启用出生消息”，“启用遗嘱消息”</p>
              <p>
                <a href="/img/home_assistant/mqtt_setting_2.png" target="_blank">
                  <img src="/img/home_assistant/mqtt_setting_2.png" class="img-big">
                </a>
              </p>
            </div>
          </li>
          <li class="step-item active">设置configuration</li>
        </ul>
        <div class="my-4">
          <div class="row">
            <div class="col-6">
              <a class="btn btn-default w-100" @click="goStep(2)">上一步 选择MQTT</a>
            </div>
            <div class="col-6">
              <a class="btn btn-primary w-100" @click="goStep(4)">下一步 设置configuration</a>
            </div>
          </div>
        </div>
      </div>
      <!-- 4 -->
      <div class="container container-tight py-4" v-if="step == 4">
        <h2 class="mb-3">设置configuration</h2>
        <p class="text-secondary mb-4">
          <a href="https://www.home-assistant.io/docs/configuration/" target="_blank">
            官方参考文档（英文）
          </a>
        </p>
        <ul class="steps steps-counter steps-vertical">
          <li class="step-item">
            <div class="h4 m-0"><i class="fa-solid fa-gear"></i> 添加设置</div>
            <div class="text-secondary">
              <p></p>
              configuration.yaml的路径：<br />
              配置->修复->右上角三个点->系统信息->配置目录<br />
              不同的操作系统，路径不同，以下仅供参考。 <p></p>
              <div class="card">
                <div class="table-responsive">
                  <table class="table table-vcenter card-table table-striped">
                    <thead>
                      <tr>
                        <th>操作系统</th>
                        <th>路径</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>macOS</td>
                        <td>~/.homeassistant</td>
                      </tr>
                      <tr>
                        <td>Linux</td>
                        <td>~/.homeassistant</td>
                      </tr>
                      <tr>
                        <td>Windows</td>
                        <td>%APPDATA%/.homeassistant</td>
                      </tr>
                      <tr>
                        <td>Docker</td>
                        <td>您自定义映射路径，或/config</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <p></p>
              <p>在configuration.yaml文件末尾，添加以下内容。</p>
              <p>
              <pre>mqtt: !include mqtt.yaml</pre>
              </p>
              <p>
                <a href="/img/home_assistant/mqtt_config_1.png" target="_blank">
                  <img src="/img/home_assistant/mqtt_config_1.png" class="img-big">
                </a>
              </p>
            </div>
          </li>
          <li class="step-item">
            <div class="h4 m-0"><i class="fa-solid fa-file-code"></i> 下载mqtt.yaml文件</div>
            <div class="text-secondary">
              <p></p>
              <p>我们已经根据您的设备信息，生成了mqtt.yaml文件。您只需要下载此文件，然后放在和configuration.yaml文件相同目录下。</p>
              <p>⚠️ 如果您只是想控制单个设备，请下载设备名称后面的配置</p>
              <p>⚠️ 如果您想控制所有设备，请“下载以上所有设备的配置”</p>
              <p></p>
              <div class="card">
                <div class="table-responsive">
                  <table class="table table-vcenter card-table table-striped">
                    <thead>
                      <tr>
                        <th>设备名称</th>
                        <th>下载配置</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in deviceList" v-bind:key="item.id">
                        <td><img :src="'https://file.sumsg.com/app/sumsg/icon/' + item.myIcon + '.png'"
                            style="width: 30px;height: 30px;"> {{ item.deviceName }}</td>
                        <td><a href="#" @click="getDeviceConfig(item)">下载配置</a></td>
                      </tr>
                      <tr v-if="deviceList.length > 0">
                        <td colspan="2"><a href="#" @click="getAllDeviceConfig()">下载以上所有设备的配置</a></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <!-- <p></p> -->
              <!-- <p>
                <a href="/img/home_assistant/mqtt_config_2.png" target="_blank">
                  <img src="/img/home_assistant/mqtt_config_2.png" class="img-big">
                </a>
              </p> -->
            </div>
          </li>
          <li class="step-item">
            <div class="h4 m-0"><i class="fa-solid fa-arrow-rotate-left"></i> 重启Home Assistant</div>
            <div class="text-secondary">
              <p></p>
              <p>在“开发者工具”中，“快速重载”，使新的设置生效。如果“快速重载”不起作用，请“重新启动Home Assistant”</p>
              <p>
                <a href="/img/home_assistant/restart.png" target="_blank">
                  <img src="/img/home_assistant/restart.png" class="img-big">
                </a>
              </p>
            </div>
          </li>

        </ul>
        <div class="my-4">
          <div class="row">
            <div class="col-6">
              <a class="btn btn-default w-100" @click="goStep(3)">上一步 设置MQTT</a>
            </div>
            <div class="col-6">
              <a class="btn btn-primary w-100" @click="goStep(5)">完成</a>
            </div>
          </div>
        </div>
      </div>
      <!-- 5 -->
      <div class="container container-tight py-4" v-if="step == 5">
        <h2 class="mb-3">完成</h2>
        <p class="text-secondary mb-4">
          恭喜您，现在您可以在Home Assistant中体验了。
        </p>
        <ul class="steps steps-counter steps-vertical">
          <li class="step-item">
            <div class="h4 m-0"><i class="fa-solid fa-laptop-mobile"></i> 集成</div>
            <div class="text-secondary">
              <p></p>
              <p>这是在集成中展示的界面</p>
              <p>
                <a href="/img/home_assistant/show_1.png" target="_blank">
                  <img src="/img/home_assistant/show_1.png" class="img-big">
                </a>
              </p>
            </div>
          </li>
          <li class="step-item">
            <div class="h4 m-0"><i class="fa fa-solid fa-bars-progress"></i> 概览</div>
            <div class="text-secondary">
              <p></p>
              <p>这是在概览中展示的界面</p>
              <p>
                <a href="/img/home_assistant/show_2.png" target="_blank">
                  <img src="/img/home_assistant/show_2.png" class="img-big">
                </a>
              </p>
            </div>
          </li>
        </ul>
        <div class="my-4">
          <a class="btn btn-default w-100" @click="goStep(4)">上一步 设置configuration</a>
        </div>
      </div>
    </div>
  </div>

  <FooterBlock msg="FooterBlock" />
</template>

<script>
import HeaderBlock from '../components/HeaderBlock.vue'
import FooterBlock from '../components/FooterBlock.vue'
import NavBlock from '../components/NavBlock.vue'
import { global } from '../global.js'
import md5 from 'crypto-js/md5'
export default {
  name: 'HomeAssistantPage',
  components: {
    HeaderBlock,
    FooterBlock,
    NavBlock,
  },
  data() {
    return {
      global: global,
      step: 1,
      MQTTConfig: {
        "broker": "broker.iot.sumsg.com",
        "port": 1316,
        "username": "",
        "password": "",
      },
      deviceList: [],
    };
  },
  methods: {
    goStep: function (s) {
      this.step = s;
    },
    getMQTTConfig: function () {
      global.postData("user/user_profile", {}, { token: true })
        .then(data => {
          if (data.code == 200) {
            this.MQTTConfig.username = data.body.auth.user;
            this.MQTTConfig.password = data.body.auth.pass;
          }
        });
    },
    getDeviceList: function () {
      global.postData("device/v3/device_list", {}, { token: true })
        .then(data => {
          if (data.code == 200) {
            data.body.deviceList.forEach(el => {
              if (el.type == 'BOOT_SWITCH') {
                this.deviceList.push(el);
              }
            });
          }
        });
    },
    getSwitch: function (device) {
      let unique_id = `${device.productName}_${device.token}`;
      let server_topic = `su/${device.productName}/${device.token}/server`;
      let client_topic = `su/${device.productName}/${device.token}/client`;
      return `- name: "电源"
    icon: "mdi:power"
    unique_id: "${unique_id}_power"
    state_topic: "${server_topic}"
    command_topic: "${client_topic}"
    payload_on: '${this.deviceAction(2, device)}'
    payload_off: '${this.deviceAction(1, device)}'
    value_template: '{{ value_json.ps }}'
    state_on: 1
    state_off: 0
    device: 
      name: "${device.deviceName}"
      manufacturer: "SUMSG"
      identifiers: "${device.token}"
      model: "${device.productName.toUpperCase()}"
      hw_version: "2.0.0"
      configuration_url: "https://u.sumsg.com/home_assistant"
  - name: "来电自启"
    icon: "mdi:auto-mode"
    unique_id: "${unique_id}_autoboot"
    state_topic: "${server_topic}"
    command_topic: "${client_topic}"
    payload_on: '${this.deviceAction(5, device)}'
    payload_off: '${this.deviceAction(5, device)}'
    value_template: '{{ value_json.au }}'
    state_on: 1
    state_off: 0
    device: 
      identifiers: "${device.token}"
  - name: "童锁"
    icon: "mdi:lock"
    unique_id: "${unique_id}_childlock"
    state_topic: "${server_topic}"
    command_topic: "${client_topic}"
    payload_on: '${this.deviceAction(6, device)}'
    payload_off: '${this.deviceAction(6, device)}'
    value_template: '{{ value_json.lc }}'
    state_on: 1
    state_off: 0
    device: 
      identifiers: "${device.token}"`;
    },

    getButton: function (device) {
      let unique_id = `${device.productName}_${device.token}`;
      let client_topic = `su/${device.productName}/${device.token}/client`;
      return `- name: "重启"
    icon: "mdi:restart"
    unique_id: "${unique_id}_restart"
    command_topic: '${client_topic}'
    payload_press: '${this.deviceAction(3, device)}'
    device: 
      identifiers: "${device.token}"
  - name: "强制关机"
    icon: "mdi:television-stop"
    unique_id: "${unique_id}_forceoff"
    command_topic: '${client_topic}'
    payload_press: '${this.deviceAction(4, device)}'
    device: 
      identifiers: "${device.token}"`;
    },
    getSensor: function (device) {
      let unique_id = `${device.productName}_${device.token}`;
      let server_topic = `su/${device.productName}/${device.token}/server`;
      return `- name: "机箱温度"
    icon: "mdi:thermometer"
    unique_id: "${unique_id}_boxtemp"
    state_topic: "${server_topic}"
    value_template: '{{ value_json.tp }}'
    unit_of_measurement: "°C"
    device: 
      identifiers: "${device.token}"`;
    },
    getDeviceConfig: function (device) {
      let data = `switch:
  ${this.getSwitch(device)}
button:
  ${this.getButton(device)}
sensor:
  ${this.getSensor(device)}`;
      this.downloadYaml(data, "mqtt.yaml");
    },
    deviceAction: function (cmd, device) {
      return JSON.stringify({
        'c': 'SW',
        's': cmd,
        'tk': md5(device.token + device.productName + 'SW').toString(),
      });
    },
    getAllDeviceConfig: function () {
      if (this.deviceList.length == 0) return;
      let data = 'switch:\n';
      for (let i = 0; i < this.deviceList.length; i++) {
        data = data + '  ' + this.getSwitch(this.deviceList[i]) + '\n';
      }
      data = data + '\nbutton:\n';
      for (let i = 0; i < this.deviceList.length; i++) {
        data = data + '  ' + this.getButton(this.deviceList[i]) + '\n';
      }
      data = data + '\nsensor:\n';
      for (let i = 0; i < this.deviceList.length; i++) {
        data = data + '  ' + this.getSensor(this.deviceList[i]) + '\n';
      }
      this.downloadYaml(data, "mqtt.yaml");
    },
    downloadYaml: function (content, filename) {
      var eleLink = document.createElement('a')
      eleLink.download = filename
      eleLink.style.display = 'none'
      var blob = new Blob([content])
      eleLink.href = URL.createObjectURL(blob)
      document.body.appendChild(eleLink)
      eleLink.click()
      document.body.removeChild(eleLink)
    }
  },
  created() {
    this.getMQTTConfig();
    this.getDeviceList();
  },
}
</script>
<style scoped>
.img-big {
  border-radius: 5px;
  border: 1px solid #206bc4;
  padding: 2px;
  margin-right: 5px;
}

.card-border {
  border: 1px solid #206bc4;
}
</style>